'use es6';

import { Map as ImmutableMap } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
const initialState = ImmutableMap();
export default function ContentById(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_LESSONS_RECEIVE:
    case ActionTypes.GET_LESSON_BY_ID_RECEIVE:
    case ActionTypes.TRACK_BY_ID_RECEIVE:
    case ActionTypes.TRACKS_RECEIVED:
      {
        return state.merge(action.payload.contentById);
      }
    default:
      return state;
  }
}